import { render, staticRenderFns } from "./groups.html?vue&type=template&id=0a44c356&scoped=true&"
import script from "./groups.js?vue&type=script&lang=js&"
export * from "./groups.js?vue&type=script&lang=js&"
import style0 from "./groups.scss?vue&type=style&index=0&id=0a44c356&prod&scoped=true&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44c356",
  null
  
)

export default component.exports